module.exports = __webpack_public_path__ + "img/free-suggestion.d3a641e8.png";